import { bffServiceInstanceClient } from "@/plugins/api_service/services";

const prefix = "/member/auth";

export default {
  login: (body) => bffServiceInstanceClient.post(`${prefix}/login`, {}, body),
  logout: () => bffServiceInstanceClient.post(`${prefix}/logout`, {}, {}),
  getInfo: () => bffServiceInstanceClient.get(`${prefix}/get-info`),
};
